const helper = {
  onHeaderEnter: (e, wrapperClass, addClass) => {
    const numberOfCellsBeforeGrades = 1;
    const allRowCells = Array.prototype.slice.call(e.target.closest('tr').children);
    const index = allRowCells.indexOf(e.target.closest('th'));

    document
      .querySelectorAll(`.${wrapperClass} tr > td:nth-child(${index + numberOfCellsBeforeGrades})`)
      .forEach(element => {
        element.classList.add(addClass);
      });
  },
  onHeaderLeave: removeClass => {
    document.querySelectorAll(`.${removeClass}`).forEach(element => {
      element.classList.remove(removeClass);
    });
  },
};

export default helper;
